import { animate, state, style, transition, trigger } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faChevronDown } from '@fortawesome/pro-light-svg-icons';

@Component({
  selector: 'collapse',
  standalone: true,
  imports: [CommonModule, FontAwesomeModule],
  templateUrl: './collapse.component.html',
  styleUrl: './collapse.component.scss',
  animations: [
    trigger('expandAnimation', [
      state('collapsed', style({ opacity: '0', height: '0', pointerEvents: 'none' })
      ),
      state('expanded', style({ opacity: '1', height: '*', pointerEvents: 'all' })),
      transition('collapsed <=> expanded', animate('300ms ease-in-out')),
    ]),
  ],
})
export class CollapseComponent {
  faChevronCircleDown = faChevronDown
  @Input() isFilters: boolean = false;
  @Input() title: string = '';
  @Input() icono: any = '';
  @Input() typeicon: string = '';
  @Input() balance: string = '';
  @Input() type: string = '';
  @Input() state: any = '';
  @Input() open: boolean = false;
  @Input() borderRadius: string = '1.5rem';
  @Input() paddingCollapse: string = '0.75rem';
  @Input() img: boolean = false;
  @Input() showLess: boolean = true;
  @Input() titleStyle: string = '';
  @Input() boxshadow: string = '0px 0px 16px #13a0d31a';


  expanded = false;

  toggleExpand(): void {
    this.expanded = !this.expanded;
  }
  ngOnInit(): void {
    if (this.isFilters == true) {
      this.borderRadius = "0"
      this.paddingCollapse = "0rem 5.25rem 0rem 4.5rem"
    }
    if (this.open) {
      this.expanded = true
    } else {
      this.expanded = false
    }
  }
}
